import { render } from "./active-order.vue?vue&type=template&id=5416dc20&scoped=true"
import script from "./active-order.vue?vue&type=script&lang=js"
export * from "./active-order.vue?vue&type=script&lang=js"

import "./active-order.vue?vue&type=style&index=0&id=5416dc20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5416dc20"]])

export default __exports__